<h2 mat-dialog-title class="dialog-title">
  Access Rights for property {{ data.propertyName }} in group
  {{ data.propertyGroupName }}
</h2>

<mat-dialog-content class="dialog-content">
  <table
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z1 full-width-table"
  >
    <ng-container matColumnDef="profile">
      <th mat-header-cell *matHeaderCellDef>Profile Name</th>
      <td
        mat-cell
        *matCellDef="let element; let i = index"
        [ngClass]="{ 'italic-text': i === dataSource.length - 1 }"
      >
        {{ element.profile }}
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="originators">
      <th mat-header-cell *matHeaderCellDef>Associated Originators</th>
      <td mat-cell *matCellDef="let element">{{ element.originators }}</td>
    </ng-container> -->

    <ng-container matColumnDef="read">
      <th mat-header-cell *matHeaderCellDef>Read</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <span
          *ngIf="i !== dataSource.length - 1; else readOnlyCellRead"
          class="clickable"
          [ngClass]="element.read ? 'green-check' : 'red-x'"
          (click)="toggleRead(element)"
        >
          {{ element.read ? "✔" : "✗" }}
        </span>
        <ng-template #readOnlyCellRead>
          <span [ngClass]="element.read ? 'green-check' : 'red-x'">
            {{ element.read ? "✔" : "✗" }}
          </span>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="create">
      <th mat-header-cell *matHeaderCellDef>Create</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <span
          *ngIf="i !== dataSource.length - 1; else readOnlyCellCreate"
          class="clickable"
          [ngClass]="element.create ? 'green-check' : 'red-x'"
          (click)="toggleCreate(element)"
        >
          {{ element.create ? "✔" : "✗" }}
        </span>
        <ng-template #readOnlyCellCreate>
          <span [ngClass]="element.create ? 'green-check' : 'red-x'">
            {{ element.create ? "✔" : "✗" }}
          </span>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="update">
      <th mat-header-cell *matHeaderCellDef>Update</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <span
          *ngIf="i !== dataSource.length - 1; else readOnlyCellUpdate"
          class="clickable"
          [ngClass]="element.update ? 'green-check' : 'red-x'"
          (click)="toggleUpdate(element)"
        >
          {{ element.update ? "✔" : "✗" }}
        </span>
        <ng-template #readOnlyCellUpdate>
          <span [ngClass]="element.update ? 'green-check' : 'red-x'">
            {{ element.update ? "✔" : "✗" }}
          </span>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="decommission">
      <th mat-header-cell *matHeaderCellDef>Set to nil</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <span
          *ngIf="i !== dataSource.length - 1; else readOnlyCellUpdate"
          class="clickable"
          [ngClass]="element.decommission ? 'green-check' : 'red-x'"
          (click)="toggleDecommission(element)"
        >
          {{ element.decommission ? "✔" : "✗" }}
        </span>
        <ng-template #readOnlyCellUpdate>
          <span [ngClass]="element.decommission ? 'green-check' : 'red-x'">
            {{ element.update ? "✔" : "✗" }}
          </span>
        </ng-template>
      </td>
    </ng-container>

<ng-container matColumnDef="mandatory">
  <th mat-header-cell *matHeaderCellDef>Mandatory</th>
  <td mat-cell *matCellDef="let element; let i = index">
    <ng-container *ngIf="element.mandatory === 'N/A'; else editableMandatory">
      <span class="na-text">N/A</span>
    </ng-container>
    <ng-template #editableMandatory>
      <span
        *ngIf="i !== dataSource.length - 1; else readOnlyCellMandatory"
        class="clickable"
        [ngClass]="element.mandatory ? 'green-check' : 'red-x'"
        (click)="toggleMandatory(element)"
      >
        {{ element.mandatory ? '✔' : '✗' }}
      </span>
    </ng-template>
    <ng-template #readOnlyCellMandatory>
      <span [ngClass]="element.mandatory ? 'green-check' : 'red-x'">
        {{ element.mandatory ? '✔' : '✗' }}
      </span>
    </ng-template>
  </td>
</ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <ng-template #naTemplate>
      <span class="na-text">N/A</span>
    </ng-template>
  </table>

  <h2 class="dialog-subtitle thin-italic">
    Note: these permissions apply to this property for all uses of the same
    group, not only to the current feature. The group
    {{ data.propertyGroupName }} is used in the following features:
    DesignatedPoint
  </h2>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-raised-button color="primary" class="circle-btn" (click)="openAddProfileDialog()">
    <mat-icon>add</mat-icon>
  </button>

  <span class="spacer"></span>

  <button mat-raised-button color="primary" (click)="onClose()">Save</button>
  <button mat-raised-button color="primary" (click)="onLock()">Cancel</button>
</mat-dialog-actions>
